import React from 'react';
import { TrendingUp, Award, Users, BarChart3, PieChart } from 'lucide-react';

const NotesStats = ({ stats }) => {
  if (!stats) return null;

  return (
    <div className="mb-8">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
        <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-6 rounded-xl border border-blue-200">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-blue-600 text-sm font-medium mb-1">Moyenne générale</p>
              <p className="text-3xl font-bold text-blue-800">{stats.moyenne}/20</p>
            </div>
            <TrendingUp className="h-8 w-8 text-blue-600" />
          </div>
        </div>
        
        <div className="bg-gradient-to-br from-green-50 to-green-100 p-6 rounded-xl border border-green-200">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-green-600 text-sm font-medium mb-1">Étudiants ayant la moyenne</p>
              <p className="text-3xl font-bold text-green-800">{stats.reussite}</p>
              <p className="text-xs text-green-600">{stats.pourcentageReussite}% du total</p>
            </div>
            <Award className="h-8 w-8 text-green-600" />
          </div>
        </div>

        <div className="bg-gradient-to-br from-red-50 to-red-100 p-6 rounded-xl border border-red-200">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-red-600 text-sm font-medium mb-1">Étudiants n'ayant pas la moyenne</p>
              <p className="text-3xl font-bold text-red-800">{stats.echec}</p>
              <p className="text-xs text-red-600">{100 - stats.pourcentageReussite}% du total</p>
            </div>
            <Users className="h-8 w-8 text-red-600" />
          </div>
        </div>

        <div className="bg-gradient-to-br from-yellow-50 to-yellow-100 p-6 rounded-xl border border-yellow-200">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-yellow-600 text-sm font-medium mb-1">Note maximale</p>
              <p className="text-3xl font-bold text-yellow-800">{stats.max}/20</p>
            </div>
            <BarChart3 className="h-8 w-8 text-yellow-600" />
          </div>
        </div>

        <div className="bg-gradient-to-br from-purple-50 to-purple-100 p-6 rounded-xl border border-purple-200">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-purple-600 text-sm font-medium mb-1">Note minimale</p>
              <p className="text-3xl font-bold text-purple-800">{stats.min}/20</p>
            </div>
            <PieChart className="h-8 w-8 text-purple-600" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotesStats; 